import ValidateScoreValue from "../rules/scoreValue";

const ScoreRecordFormTableValidator = (value) => {
  const errors = {};


  const error = ValidateScoreValue(value);

  return error;
};

export default ScoreRecordFormTableValidator;



// WEBPACK FOOTER //
// ./src/components/validation/forms/scoreRecordFormTable.js